import { render, staticRenderFns } from "./StructureYourWarrant.vue?vue&type=template&id=72313c5b&scoped=true&"
import script from "./StructureYourWarrant.js?vue&type=script&lang=js&"
export * from "./StructureYourWarrant.js?vue&type=script&lang=js&"
import style0 from "./StructureYourWarrant.vue?vue&type=style&index=0&id=72313c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72313c5b",
  null
  
)

export default component.exports